export default __webpack_public_path__ + "static/media/monoful-brand.05b799df.svg";